<template>
  <div>
    <div class="row mb-2">
      <div class="col-auto mr-auto">
        <h3 v-html="$t('food.edit', [currentFood.name])" />
      </div>
      <div class="col-auto">
        <v-icon
          name="regular/trash-alt"
          class="actions-icon"
          :title="$t('buttons.delete')"
          @click="deleteFood"
        />
      </div>
    </div>

    <FoodForm
      :id="$route.params.id"
      :foodItem="currentFood"
      @foodSubmitted="saveFood"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "vue-awesome/icons/regular/trash-alt";
import { ROUTE_FOOD } from "../../constants";
import FoodForm from "./FoodForm";

export default {
  name: "FoodEdit",
  components: { FoodForm },
  computed: {
    ...mapGetters(["pantryAuthData", "foodById"]),
    currentFood() {
      return this.foodById(this.$route.params.id);
    }
  },
  methods: {
    saveFood(payload) {
      this.$router.push({
        name: ROUTE_FOOD
      });
    },
    deleteFood() {
      if (confirm(this.$t("food.deleteConfirm", [this.currentFood.name]))) {
        // TODO: show loading?
        this.$store.state.resources.food
          .delete({
            ...this.pantryAuthData,
            id: this.$route.params.id
          })
          .then(
            () => {
              console.log("deleted on remote: " + this.$route.params.id);
              this.$router.push({
                name: ROUTE_FOOD,
                params: { forceReload: true }
              });
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }
};
</script>

<style scoped></style>
